const source = [
        <p>ГОСТ <strong>24846-2019</strong> «Грунты. Методы измерения деформаций оснований зданий и сооружений»</p>,
        <p>РД <strong>31.35.10-86</strong> «Правила технической эксплуатации портовых сооружений и акваторий»</p>,
        <p>ГОСТ Р <strong>54523-2011</strong> Портовые гидротехнические сооружения. Правила обследования и мониторинга технического состояния</p>,
        
]
export default source;
